import { render, staticRenderFns } from "./bulk-publish.vue?vue&type=template&id=75f163f5&"
import script from "./bulk-publish.vue?vue&type=script&lang=js&"
export * from "./bulk-publish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports